<template>
  <div>
    <form-navigation-tabs
      :tabs="tabs"
      v-on:selected="setActive"
      :active="currentView"
      :enable-logging="true"
      :incident="incident"
      :parentTabs="['Recovery', 'Escalations']"
      class="margin-t-10"
    ></form-navigation-tabs>

    <solicitors
      :incident="incident"
      :section="sections.solicitor"
      v-if="currentView === 'solicitors'"
      v-on:saved="updateSection('solicitor', $event)"
      key="solicitors"
    ></solicitors>

    <keydates
      :incident="incident"
      :section="sections.key_date"
      v-if="currentView === 'keydates'"
      v-on:saved="updateSection('key_date', $event)"
      key="keydates"
    ></keydates>

    <dibs-fees
      :incident="incident"
      :section="sections.dibs_fee"
      v-if="currentView === 'dibsfees'"
      v-on:saved="updateSection('dibs_fee', $event)"
      key="dibsfees"
    ></dibs-fees>

    <settlement
      :incident="incident"
      :section="sections.settlement"
      v-if="currentView === 'settlement'"
      v-on:saved="updateSection('settlement', $event)"
      key="settlement"
    ></settlement>

    <referrals
      :incident="incident"
      :section="sections.referral"
      v-if="currentView === 'referrals'"
      v-on:saved="updateSection('referral', $event)"
      key="referrals"
    ></referrals>
  </div>
</template>

<script>
import Solicitors from './Escalations/Solicitors.vue';
import Keydates from './Escalations/Keydates.vue';
import DibsFees from './Escalations/DibsFees.vue';
import Settlement from './Escalations/Settlement.vue';
import Referrals from './Escalations/Referrals.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    Solicitors,
    Keydates,
    DibsFees,
    Settlement,
    Referrals
  },

  data() {
    return {
      currentView: 'solicitors',
      tabs: [
        { name: 'solicitors', label: 'Solicitors' },
        { name: 'keydates', label: 'Key Dates' },
        { name: 'dibsfees', label: 'DIBS/FEES' },
        { name: 'settlement', label: 'Settlement' },
        { name: 'referrals', label: 'Referrals' }
      ]
    };
  },

  computed: {
    /**
     * The recovery is loaded once by the recovery form and eager loads each of
     * the escalation sections, so the subpages need no requests of their own.
     */
    recovery() {
      return this.$store.getters['DebtRecovery/get'];
    },

    sections() {
      const recovery = this.recovery || {};

      return {
        solicitor: recovery.solicitor || null,
        key_date: recovery.key_date || null,
        dibs_fee: recovery.dibs_fee || null,
        settlement: recovery.settlement || null,
        referral: recovery.referral || null
      };
    }
  },

  methods: {
    setActive(tab) {
      this.currentView = tab;
    },

    /**
     * Keep the stored recovery in step with a section that has just been saved.
     */
    updateSection(key, data) {
      this.$store.commit('DebtRecovery/setEscalationSection', { key, data });
    }
  }
};
</script>
